import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "q-ml-sm q-mt-sm" }

import { computed } from "vue";
import { AnyCommentSchema } from "@/types";
import { getIcon } from "@/util";
import {
  artifactSaveStore,
  artifactStore,
  commentApiStore,
  commentStore,
  permissionStore,
} from "@/hooks";
import {
  PanelCard,
  Icon,
  Typography,
  Separator,
  FlexBox,
  TextButton,
} from "@/components/common";
import { ArtifactChip } from "@/components/artifact/display";
import IconButton from "@/components/common/button/IconButton.vue";


/**
 * Displays artifact health checks.
 */
const __default__ = {
  name: "ArtifactHealth",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifact = computed(() =>
  artifactSaveStore.editedArtifact.body
    ? artifactSaveStore.editedArtifact
    : artifactStore.selectedArtifact
);

const artifactHealth = computed(() =>
  commentStore.getHealthChecks(artifact.value?.id || "")
);

/**
 * Generates health checks for the current artifact.
 */
function handleCheckHealth(): void {
  if (!artifact.value) return;

  commentApiStore.handleLoadHealthChecks(artifact.value);
}

/**
 * Resolves a comment, hiding it from the list.
 * @param healthCheck - The health check to resolve.
 */
function handleResolveCheck(healthCheck: AnyCommentSchema) {
  if (!artifact.value) return;

  commentApiStore.handleResolveComment(artifact.value, healthCheck);
}

return (_ctx: any,_cache: any) => {
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_unref(permissionStore).isNASA)
    ? (_openBlock(), _createBlock(_unref(PanelCard), {
        key: 0,
        borderless: "",
        collapsable: "",
        title: "Artifact Health"
      }, {
        "title-actions": _withCtx(() => [
          _createVNode(_unref(TextButton), {
            text: "",
            loading: _unref(commentApiStore).healthLoading,
            color: "primary",
            label: "Health",
            icon: "health",
            "data-cy": "button-artifact-health",
            class: "q-mr-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCheckHealth()))
          }, null, 8, ["loading"])
        ]),
        default: _withCtx(() => [
          (artifactHealth.value.length === 0)
            ? (_openBlock(), _createBlock(_unref(Typography), {
                key: 0,
                value: "There are no active health checks."
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(artifactHealth.value, (check) => {
            return (_openBlock(), _createBlock(_component_q_banner, {
              key: check.content,
              dense: "",
              class: "show-on-hover-parent"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FlexBox), { justify: "between" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FlexBox), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Separator), {
                          vertical: "",
                          color: check.color,
                          r: "2",
                          class: "artifact-check"
                        }, null, 8, ["color"]),
                        _createVNode(_unref(Icon), {
                          size: "sm",
                          variant: check.icon,
                          color: check.color,
                          class: "q-mt-sm"
                        }, null, 8, ["variant", "color"]),
                        _createVNode(_unref(Typography), {
                          value: check.content,
                          l: "2",
                          variant: "markdown",
                          class: "q-mt-sm"
                        }, null, 8, ["value"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FlexBox), { class: "show-on-hover-child" }, {
                      default: _withCtx(() => [
                        (check.action)
                          ? (_openBlock(), _createBlock(IconButton, {
                              key: 0,
                              tooltip: check.action.tooltip,
                              icon: check.action.icon,
                              onClick: ($event: any) => (check.action.perform())
                            }, null, 8, ["tooltip", "icon", "onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(IconButton, {
                          tooltip: "Resolve",
                          icon: "comment-resolve",
                          onClick: ($event: any) => (handleResolveCheck(check))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_1, [
                  (check.artifacts.length > 0)
                    ? (_openBlock(), _createBlock(_unref(FlexBox), {
                        key: 0,
                        wrap: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(check.artifacts, (relatedArtifact) => {
                            return (_openBlock(), _createBlock(_unref(ArtifactChip), {
                              key: relatedArtifact.id,
                              artifact: relatedArtifact,
                              color: check.color
                            }, null, 8, ["artifact", "color"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (check.concepts.length > 0)
                    ? (_openBlock(), _createBlock(_unref(FlexBox), { key: 1 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(check.concepts, (concept) => {
                            return (_openBlock(), _createBlock(_component_q_chip, {
                              key: concept,
                              color: check.color,
                              outline: "",
                              icon: _unref(getIcon)('health-unknown'),
                              class: "artifact-check-chip"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Typography), {
                                  value: concept,
                                  wrap: "",
                                  color: "text"
                                }, null, 8, ["value"])
                              ]),
                              _: 2
                            }, 1032, ["color", "icon"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})